/**
 * Main application layout shell with sidebar navigation.
 * Wraps authenticated pages and fetches available modules.
 */
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";

import { trpc } from "@/lib/trpc";

/**
 * Main application shell with sidebar layout
 */
export function AppShell() {
	const modulesQuery = trpc.modules.list.useQuery();

	return (
		<div className="flex h-screen overflow-hidden">
			<Sidebar modules={modulesQuery.data ?? { groups: [], ungrouped: [] }} />
			<main className="flex-1 overflow-y-auto">
				<Outlet />
			</main>
		</div>
	);
}
